import React from "react";
import UploadOutlined from "@mui/icons-material/UploadOutlined";

import { HiddenInput, StyledUploadButton, StyledLabel } from "./FileUploadButton.styles";

const FileUploadButton = ({ id, label, accept, multiple, onChange }) => (
  <>
    <HiddenInput
      id={id}
      type="file"
      accept={accept}
      multiple={multiple}
      onChange={onChange}
    />
    <StyledLabel htmlFor={id}>
      <StyledUploadButton
        variant="outlined"
        component="span"
        startIcon={<UploadOutlined />}
      >
        {label || "Upload File"}
      </StyledUploadButton>
    </StyledLabel>
  </>
);

export default FileUploadButton;
